import { render, staticRenderFns } from "./Supervisor.vue?vue&type=template&id=2aa15f5b&scoped=true"
import script from "./Supervisor.vue?vue&type=script&lang=ts"
export * from "./Supervisor.vue?vue&type=script&lang=ts"
import style0 from "./Supervisor.vue?vue&type=style&index=0&id=2aa15f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa15f5b",
  null
  
)

export default component.exports